import {Inject, Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {ErrorPageEvent} from './events/error-page-event';
import {BehaviorSubject, Observable} from 'rxjs';
import {CxEvent, Page} from '@spartacus/core';
import {DOCUMENT} from '@angular/common';
import {PageLayoutService} from '@spartacus/storefront';
import {DcpFormatDataService} from '../dcp-format-data.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {distinctUntilChanged, filter, first, map, switchMap} from 'rxjs/operators';
import {EddlAfterInitializationEvent} from '@app/services/analytics/EDDL/events/eddl-after-initialization-event';

const ERROR_PAGE_EVENT_NAME = 'errorPage';
const ERROR_PAGE_NAME = 'errorpage';
const ERROR_PAGE_SECTION = 'errorPage';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlErrorPageViewDataLayerService extends DcpDataService<EddlAdobeTrackingData> {

  private hasBeenInitializedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    @Inject(DOCUMENT) public documentObject: Document,
    protected pageLayoutService: PageLayoutService,
    protected formatDataService: DcpFormatDataService,
  ) {
    super();
  }

  fillData(event: ErrorPageEvent, page: Page): EddlAdobeTrackingData {
    const url: string = this.formatDataService.formatUrl(this.documentObject.defaultView.location.href);
    return {
      event: ERROR_PAGE_EVENT_NAME,
      page: {
        name: ERROR_PAGE_NAME,
        section: ERROR_PAGE_SECTION,
      },
      error: {
        type: event.errorType,
        pageUrl: url,
        pageName: page.name,
        pageSection: event.pageSection,
        description: event.description,
      },
    };
  }

  getData(event: CxEvent): Observable<EddlAdobeTrackingData> | EddlAdobeTrackingData {
    if (event instanceof EddlAfterInitializationEvent) {
      this.hasBeenInitializedSubject.next(true);
    }
    if (!(event instanceof ErrorPageEvent)) {
      return undefined;
    }
    return this.hasBeenInitializedSubject.pipe(
      untilDestroyed(this),
      distinctUntilChanged(),
      filter(Boolean),
      first(),
      switchMap(() =>
        this.pageLayoutService.page$.pipe(
          untilDestroyed(this),
          first(),
          map((page) => this.fillData(event, page)))
      ));
  }
}
